module.exports = __webpack_public_path__ + "static/img/77034C_2_3_R_20190910_fit.2a4165c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77034C_2_3_R_20190910_fit.png
// module id = s98p
// module chunks = 0